import type { ColumnDef } from '@tanstack/react-table';

import { type GetThermometersQuery, type ThermometerUpdateInput } from 'data/__generated__';
import { numberColumn } from 'components/DataTable';
import { TotemCheckbox } from 'components/TotemCheckbox';
import { TotemSelect } from 'components/TotemSelect';

export type ThermometerRow = GetThermometersQuery['getThermometers'][number];

type ThermometerColumnsConfig = {
    deliveryPeopleOptions: { value: string; label: string }[];
    update: (input: ThermometerUpdateInput) => void;
    updateLoading: boolean;
};

export const getThermometersColumns = ({
    deliveryPeopleOptions,
    update,
    updateLoading,
}: ThermometerColumnsConfig): ColumnDef<ThermometerRow, unknown>[] => [
    numberColumn<ThermometerRow, Record<string, unknown>>({
        accessorKey: 'number',
        header: 'Numéro',
        defaultVisible: true,
    }),
    {
        id: 'associatedUser',
        header: 'Livreur',
        cell: ({ row }) => (
            <TotemSelect
                placeholder="Sélectionner un livreur"
                isClearable
                disabled={updateLoading}
                value={row.original.associatedUserId ?? null}
                options={deliveryPeopleOptions}
                onChange={(value) => {
                    update({ ...row.original, associatedUserId: value ?? null });
                }}
            />
        ),
        meta: { defaultVisible: true },
    } as ColumnDef<ThermometerRow, unknown>,
    {
        id: 'isOperational',
        header: 'Opérationnel',
        cell: ({ row }) => (
            <TotemCheckbox
                checked={row.original.isOperational}
                disabled={updateLoading}
                onChange={() => update({ ...row.original, isOperational: !row.original.isOperational })}
            />
        ),
        meta: { defaultVisible: true },
    } as ColumnDef<ThermometerRow, unknown>,
];
